import { useContext } from 'react'
import cx from 'classnames'

import { ButtonToneContext } from '../contexts'
import {
  buttonSizeClasses,
  buttonVariantClasses,
  heroButtonVariantClasses,
} from './buttonStyles'

export const Button = ({
  children,
  className,
  icon,
  size = 'md',
  type = 'button',
  variant = 'primary',
  ...props
}) => {
  const tone = useContext(ButtonToneContext)
  const resolvedVariantClasses = tone === 'hero'
    ? heroButtonVariantClasses[variant] || heroButtonVariantClasses.primary
    : buttonVariantClasses[variant] || buttonVariantClasses.primary

  return (
    <button
      className={cx(
        'ds-button tw:inline-flex tw:items-center tw:justify-center tw:gap-2 tw:whitespace-nowrap tw:rounded-button tw:border tw:font-medium',
        'tw:transition-[background-color,border-color,color] tw:duration-fast tw:ease-standard',
        'tw:disabled:cursor-not-allowed tw:disabled:opacity-70',
        resolvedVariantClasses,
        buttonSizeClasses[size] || buttonSizeClasses.md,
        className,
      )}
      data-tone={tone}
      data-variant={variant}
      type={type}
      {...props}
    >
      {icon && <span className="ds-button-icon tw:inline-flex">{icon}</span>}
      {children}
    </button>
  )
}
